import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Container, Row, Col, Button, Input } from 'reactstrap';
import './RecommendationsPage.css';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const QuestionStyle = {
  margin: 15,
};

const btnContainer = {
  color: 'white',
};

const ButtonStyle = {
  width: '30%',
  height: '50px',
  marginTop: '2%',
};

const patientStyle = {
  width: '70%',
  maxWidth: 'unset',
  marginTop: '80px',
  paddingBottom: '30px',
};

const successStyle = {
  marginTop: '0',
  marginBottom: '1rem',
  height: '24px',
};

// const CustomInput = props => <Input {...props} />;

// Use: include in field component prop "validate" if a field is required
const required = (value, allValues) => {

  // Validate against input which is simply just newlines
  if (value && typeof value === "string")
  {
    value = value.replace(/\n/g, "");
  }

  const isRequired = allValues !== undefined;
  const error = 'Please fill out this field';

  const output =
    isRequired && !value ? (
      <b style={{ color: 'rgb(255,0,0)' }}>{error}</b>
    ) : null;

  return output;
};

// Use: render input field with checks for warnings and errors
const renderInput = ({ input, type, meta: { touched, error, warning } }) => (
  <div>
    <Input {...input} type={type} />
    <div>
      {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
    </div>
  </div>
);

// Use: component to show status of form submission once user has clicked "Save/Submit"
const ShowMessage = ({ submission, error, change }) => {
  if (submission && error === 'no error' && !change) {
    // if the submission was successful and the form is not dirty since the user clicked the save button ...
    // and the backend responds with no error, then show this message
    return (
      <p>Saved Successfully!</p>
    );
  } else if (!change && submission && (error === '' || error === null || typeof error === 'undefined')) {
    // if there is no change and the redux submission was successful meaning the user clicked the save button ...
    // but the backend hasn't given a status reporting meaning that it's still fetching, then show a spinner ...
    // to show that the submission is still in progress
    return (
      <div>
        <BeatLoader
          css={override}
          sizeUnit="px"
          size={10}
          color="#41AAD9"
        />
      </div>
    );
  }
  // otherwise show nothing
  return (
    <div style={successStyle} />
  );
};


const RecommendationsForm = (props) => {
  const {
    handleSubmit,
    pristine,
    handleSave,
    submitting,
    changed,
    handleChange,
    noError,
    submitSucceeded,
    invalid,
  } = props;

  return (
    <div className="recommendations-form">
      <form onSubmit={handleSubmit}>
        <Container style={patientStyle}>
          <Row style={QuestionStyle}>
            <Col xs="4">Follow Up Recommendation</Col>
            <Col xs="8">
              <Input
                tag={Field}
                autoComplete="new-password"
                name="followUp"
                id="followUp"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                type="textarea"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col xs="4">Detailed Recommendation</Col>
            <Col xs="8">
              <Input
                tag={Field}
                autoComplete="new-password"
                name="detailed"
                id="detailed"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                type="textarea"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>

          <div style={btnContainer}>
            <Button
              type="submit"
              style={ButtonStyle}
              color="success"
              disabled={pristine || submitting || invalid || (submitSucceeded && (noError === null || typeof noError === 'undefined'))}
              onClick={handleSave}
            >
                    Save
            </Button>
          </div>
          <div>
            <ShowMessage
              submission={submitSucceeded}
              error={noError}
              change={changed}
            />
          </div>

        </Container>
      </form>

    </div>
  );
};

export default reduxForm({
  form: 'recommendationsForm',
  destroyOnUnmount: true,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true,
  onSubmit: () => {},
  onSubmitSuccess: (val, props) => { /*props.onSubmit(val);*/ },
})(RecommendationsForm);



// WEBPACK FOOTER //
// ./src/components/RecommendationsPage/RecommendationsForm.js